import _extends from '@babel/runtime/helpers/extends';
import React__default, { useCallback } from 'react';
import { D as Dropdown } from '../../Dropdown/Dropdown-DqKIklfo.js';
import { D as DropdownItem } from '../../Dropdown/DropdownItem/DropdownItem-CW-OsnfL.js';

function parseToNum(strToParse) {
  const parsed = parseInt(strToParse, 10);
  if (isNaN(parsed)) return 0;
  return parsed;
}
const renderDefaultPaginationDropdownLabel = pageSize => `${pageSize}`;
const PaginationDropdown = props => {
  const {
    id,
    currentSize,
    disabled = false,
    size = 'base',
    pageSizes,
    onSetPageSize,
    renderPaginationDropdownLabel = renderDefaultPaginationDropdownLabel,
    ...rest
  } = props;
  const handleOverrideLabel = useCallback(label => renderPaginationDropdownLabel === null || renderPaginationDropdownLabel === void 0 ? void 0 : renderPaginationDropdownLabel(parseToNum(label)), [renderPaginationDropdownLabel]);
  const handleSetPageSize = useCallback(pageSize => onSetPageSize(parseToNum(pageSize)), [onSetPageSize]);
  return /*#__PURE__*/React__default.createElement(Dropdown, _extends({}, rest, {
    id: id,
    disabled: disabled,
    selectedValue: currentSize.toString(),
    onChange: handleSetPageSize,
    onOverrideLabel: handleOverrideLabel,
    small: size === 'small'
  }), pageSizes.map(pageSize => /*#__PURE__*/React__default.createElement(DropdownItem, {
    id: `${id}-${pageSize}`,
    key: pageSize.toString(),
    value: pageSize.toString()
  }, pageSize)));
};

export { PaginationDropdown as P };
//# sourceMappingURL=PaginationDropdown-KOYdvoLF.js.map
